import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = props => (
  <Header {...props}>
    Carbon&nbsp;<span>Design System</span>
  </Header>
);

export default CustomHeader;
